import React from 'react';
import './MainContent.scss';

type IProp = {
  centered?: boolean;
  children: React.ReactElement;
};

export function MainContent({ centered, children }: IProp) {
  return (
    <React.Fragment>
      <div className={'main-container'}>
        <div
          className={`${'content'} ${
            centered ? 'content-centered' : 'content-max'
          }`}
        >
          {children}
        </div>
      </div>
    </React.Fragment>
  );
}
